import React, { useState, useEffect } from "react";
import AddEditSection from "../../components/AddEditSection";
import Breadcrumb from "../../parts/Breadcrumb";
import labels from "../../constants/HelpCategory";
import commonConstant from "../../constants/Common";
import configuration from "../../config";
import { toast } from "react-toastify";
import UND from "underscore";
import { getAccessRights } from "../../utils/common";
import Loader from "../../components/Loader/Loader";

// For Add Help Category
function Add({ history }) {
  const [fields, setFields] = useState({});
  const [languages, setLanguages] = useState([]);
  const [errors, setErrors] = useState({});
  const [isLoader, setIsLoader] = useState(false);

  const statusOpt = [
    { id: 1, title: "Active", value: "active" },
    { id: 2, title: "Inactive", value: "inactive" },
    { id: 3, title: "Archive", value: "archive" },
  ];

  const [fieldArr, setFieldArr] = useState([
    {
      id: 0,
      title: "User Type",
      name: "user_type",
      type: "Dropdown",
      options: commonConstant.user_type,
    },
    {
      id: 2,
      title: "Status",
      name: "status",
      type: "Dropdown",
      options: statusOpt,
    },
  ]);

  useEffect(() => {
    getAccessRights().then((rights) => {
      const rightsData = rights?.find((ac) => ac.code === "HELP_CATEGORIES");
      if (rightsData?.add === false) {
        history.push("/dashboard");
      }
    });

    setIsLoader(true);
    configuration
      .getAPI({
        url: "common/list-order-no",
        params: { lang_code: "EN", collectionName: "help_categories" },
      })
      .then((data) => {
        if (data.status === 200) {
          const orderNoArr = data.payload.map((singleRec) => ({
            title: singleRec.title,
            value: singleRec.order_no,
            id: singleRec.order_no,
          }));

          const orderNoObj = {
            id: 1,
            title: "Order No",
            name: "order_no",
            type: "Dropdown",
            options: orderNoArr,
          };

          // Overwrite the Order No field if it exists, otherwise add it
          setFieldArr((prev) => {
            const withoutOrderNo = prev.filter((f) => f.name !== "order_no");
            return [...withoutOrderNo, orderNoObj];
          });
        }
      })
      .catch((error) => {
        toast.error(error.message);
      });

    configuration
      .getAPI({ url: "language/list", params: { status: "active" } })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          setLanguages(data.payload);

          const fieldArr_data = data.payload.map((language, index) => ({
            id: 3 + index,
            title: `Title [${language.title}]`,
            name: `title_${language.code}`,
            type: "TextInput",
          }));

          setFieldArr((prev) => [...prev, ...fieldArr_data]);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        toast.error(error.message);
      });
  }, []);

  function handleValidation() {
    let flag = true;
    let error = {};
    if (!fields.user_type) {
      error["user_type"] = "Please select user type";
      flag = false;
    }
    if (!fields.order_no) {
      error["order_no"] = "Please enter order no";
      flag = false;
    }
    if (!fields.status) {
      error["status"] = "Please select status";
      flag = false;
    }
    UND.each(languages, (lang, ind) => {
      if (!fields["title_" + lang.code]) {
        error["title_" + lang.code] = "Please enter title in " + lang.title;
        flag = false;
      }
    });
    setErrors({ ...error });
    return flag;
  }

  function handleChange(field, e) {
    setFields({ ...fields, [field]: e.target.value });
  }

  const handleSubmit = () => {
    if (handleValidation()) {
      setIsLoader(true);
      configuration
        .postAPI({ url: "help-category/create", params: fields })
        .then((data) => {
          setIsLoader(false);
          if (data.status === 200) {
            history.push("/help-category");
            toast.success("Record added successfully");
          } else if (data.status === 404) {
            return toast.error(data.error.message);
          } else {
            return toast.error("Something went wrong");
          }
        })
        .catch((error) => {
          setIsLoader(false);
          return toast.error(error.message);
        });
    }
  };

  return (
    <>
      {isLoader ? <Loader /> : ""}
      <Breadcrumb module={labels.addHelpCategory} />
      <AddEditSection
        title="Add Help Category"
        path="/help-category"
        fields={fieldArr}
        fieldError={errors}
        fieldValue={fields}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
      />
    </>
  );
}

export default Add;
